import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import CommonBreadcrumb from "../common_components/breadcrumb/CommonBreadcrumb";

import Cancellation_Policy_Inner from "./cancellation_policy_inner/Cancellation_Policy_Inner";
import Cancellation_Tab from "./cancellation_tab/Cancellation_Tab";
import { useDispatch, useSelector } from "react-redux";
import {
  AllCancellationContent,
  AllCancellationPolicy,
} from "../../features/admin/common/Slice";

const Cancellation_policy = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("1");

  const all_cancellation_policy_content = useSelector(
    (state) => state?.common?.all_cancellation_policy_content,
  );

  const all_cancellation_policy = useSelector(
    (state) => state?.common?.all_cancellation_policy,
  );

  const breadcrumbItems = [
    { label: "Home", link: "/home" },
    { label: "Cancellation Policy" },
  ];

  useEffect(() => {
    dispatch(AllCancellationContent());
    dispatch(AllCancellationPolicy());
  }, [dispatch]);

  return (
    <section className="privacy-section">
      <div>
        <CommonBreadcrumb items={breadcrumbItems} />
      </div>
      <Container>
        <div className="privacy-wrapper">
          {/* Left Side */}
          <aside className="privacy-sidebar ">
            <div className="privacy-tab-sticky">
              <Cancellation_Tab
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                all_cancellation_policy_content={
                  all_cancellation_policy_content
                }
              />
            </div>
          </aside>

          {/* Right Side */}
          <div className="privacy-content">
            <Cancellation_Policy_Inner
              activeTab={activeTab}
              all_cancellation_policy={all_cancellation_policy}
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Cancellation_policy;
